import React, { useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ClinicServiceOption } from './ClinicServiceOption';

export const ClinicServiceDockForm = (props) => {
  const { init_clinic_service, options } = props;
  const [currentDock, setCurrentDock] = useState(init_clinic_service);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeEnabled = () => {
    setCurrentDock({
      ...currentDock,
      enabled: !currentDock.enabled,
    })
  }

  const onChangeData = (e) => {
    setCurrentDock({
      ...currentDock,
      [e.target.name]: e.target.value,
    })
  };

  const onClickClinicServiceDockUpdate = () => {
    var data = {
      clinic_service: {
        enabled: currentDock.enabled,
        base_price: parseInt(currentDock.base_price, 10),
        dock_barium_price: parseInt(currentDock.dock_barium_price, 10),
        dock_mouth_price: parseInt(currentDock.dock_mouth_price, 10),
        dock_nose_price: parseInt(currentDock.dock_nose_price, 10),
      },
      id: currentDock.id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/clinic_services/${currentDock.id}`, data)
    .then(resp => {
      console.log("ClinicServiceDock Update api ok");
      console.log(resp.data);
      notify("success", "ClinicServiceDock Update Success!");
    })
    .catch(e => {
      console.log("ClinicServiceDock Update api ng");
      console.log(e.response);
      setCurrentDock({ 
        ...currentRegular,
        enabled: init_clinic_service.enabled,
        base_price: init_clinic_service.base_price,
        dock_barium_price: init_clinic_service.dock_barium_price,
        dock_mouth_price: init_clinic_service.dock_mouth_price,
        dock_nose_price: init_clinic_service.dock_nose_price,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ClinicServiceDock Update Error!");
    });
  }

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingDock">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseDock" aria-expanded="true" aria-controls="panelsStayOpen-collapseDock">
            人間ドック
          </button>
        </h2>
        <div id="panelsStayOpen-collapseDock" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingDock">
          <div className="accordion-body">
            <div className="row">
              <div className="col mb-3">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" id="flexSwitchCheckCheckedDock" checked={currentDock.enabled} onChange={onChangeEnabled} />
                  <label className="form-check-label" htmlFor="flexSwitchCheckCheckedDock">人間ドック可能</label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col col-md-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-base_price">基本料金</span>
                  <input type="number" name="base_price" className="form-control" id="basic-base_price" value={currentDock.base_price || ''} onChange={onChangeData} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-dock_barium_price">バリウム</span>
                  <input type="number" name="dock_barium_price" className="form-control" id="basic-dock_barium_price" value={currentDock.dock_barium_price || ''} onChange={onChangeData} />
                </div>
              </div>
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-dock_mouth_price">経口内視鏡</span>
                  <input type="number" name="dock_mouth_price" className="form-control" id="basic-dock_mouth_price" value={currentDock.dock_mouth_price || ''} onChange={onChangeData} />
                </div>
              </div>
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-dock_nose_price">経鼻内視鏡</span>
                  <input type="number" name="dock_nose_price" className="form-control" id="basic-dock_nose_price" value={currentDock.dock_nose_price || ''} onChange={onChangeData} />
                </div>
              </div>
            </div>

            <div className="d-grid gap-2 col-3 mx-auto">
              <button 
                className="btn btn-primary" 
                type="button"
                onClick={onClickClinicServiceDockUpdate}
              >
                内容更新
              </button>
            </div>

            <hr />

            <ClinicServiceOption init_clinic_service={init_clinic_service} options={options} />
          </div>
        </div>
      </div>
    </>
  );
};